/*!
 * STYRKR CEL50 — same cart contract as wk5-welcome-kit-cart.js
 * (clear cart → add deal line items → checkout). Avoids theme cart.liquid ?cart=open redirect.
 */
;(function () {
  if (window.__cel50CartInit) return
  window.__cel50CartInit = true

  function shopifyRoot() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/'
  }

  window.cel50SelectDealQuantity = function (qty) {
    var tables = document.querySelectorAll('.cel50-deals-table')
    if (!tables.length) return

    tables.forEach(function (table) {
      table.classList.toggle('selected', String(table.dataset.quantity) === String(qty))
    })
  }

  function selectedDealTable() {
    var selected = document.querySelector('.cel50-deals-table.selected')
    if (selected) return selected

    selected = document.querySelector('.cel50-deals-table')
    if (selected) selected.classList.add('selected')
    return selected
  }

  function cartItemsFromSelectedDeal() {
    var table = selectedDealTable()
    if (!table) return null

    var items = Array.prototype.slice
      .call(table.querySelectorAll('.deals-table-row[data-product-id]'))
      .map(function (row) {
        return {
          id: row.dataset.productId,
          quantity: Number(row.dataset.productQuantity),
          properties: { _promo: 'cel50-trio' },
        }
      })
      .filter(function (item) {
        return item.id && item.quantity > 0
      })
      .reverse()

    /* Buy-3 free matching-flavour gel. The gel variant for the current flavour is
       written onto the selected deal table by the buy-box section JS (data-gel-variant),
       so it stays flavour-correct. Only at qty >= 3, and only if a gel id is present. */
    var dealQty = Number(table.dataset.quantity) || 0
    var gelVariant = (table.dataset.gelVariant || '').trim()
    if (dealQty >= 3 && gelVariant) {
      items.push({ id: gelVariant, quantity: 1, properties: { _promo: 'cel50-trio' } })
    }

    return items
  }

  function labelEl(button) {
    return (
      button.querySelector('[data-cta-label], [data-sticky-label]') || button
    )
  }

  function setButtonState(button, text) {
    var label = labelEl(button)
    if (label) label.textContent = text
  }

  function readPlanInput(form) {
    var input = form.querySelector('[data-input-plan]')
    if (!input || input.disabled) return ''
    return (input.value || '').trim()
  }

  function buildBundleItem(form) {
    var variantInput = form.querySelector('[data-bundle-variant]')
    var qtyInput = form.querySelector('input[name="quantity"]')
    var variantId = variantInput ? String(variantInput.value || '').trim() : ''
    var quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1

    if (!variantId) return null
    return { id: variantId, quantity: quantity, properties: { _promo: 'cel50-trio' } }
  }

  function goToWaitlist() {
    var wl = document.querySelector('[data-cel50-waitlist]')
    if (wl) wl.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }

  function handleCheckout(form, submitter) {
    if (form.dataset.cel50Adding === '1') return

    var isBuyBox = form.matches('[data-cel50-form]')
    var items = isBuyBox ? cartItemsFromSelectedDeal() : null
    if (!items || !items.length) {
      var bundleItem = buildBundleItem(form)
      if (bundleItem) items = [bundleItem]
    }

    var button =
      submitter ||
      form.querySelector('[data-cta], [type="submit"].cel50bn__cta, button[type="submit"]')

    if (!items || !items.length) {
      goToWaitlist()
      return
    }

    var sellingPlan = isBuyBox ? readPlanInput(form) : ''
    if (sellingPlan && items.length === 1) {
      items[0].selling_plan = sellingPlan
    }

    form.dataset.cel50Adding = '1'
    var prevText = button ? labelEl(button).textContent : ''
    if (button) {
      setButtonState(button, 'Adding…')
      button.disabled = true
    }

    fetch(shopifyRoot() + 'cart/clear.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
    })
      .then(function () {
        return fetch(shopifyRoot() + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ items: items }),
        })
      })
      .then(function (res) {
        return res.json().then(function (data) {
          return { res: res, data: data }
        })
      })
      .then(function (result) {
        if (result.data && result.data.status === 422) {
          if (button) {
            setButtonState(button, 'Not enough stock')
            button.style.backgroundColor = 'red'
            button.disabled = false
          }
          delete form.dataset.cel50Adding
          return
        }
        if (!result.res.ok) throw new Error('cart add failed')
        window.location.href = shopifyRoot() + 'checkout'
      })
      .catch(function (err) {
        console.error('CEL50 cart error:', err)
        if (button) {
          setButtonState(button, prevText || 'Try again')
          button.disabled = false
          button.style.backgroundColor = ''
        }
        delete form.dataset.cel50Adding
      })
  }

  function onReady() {
    if (!document.querySelector('.cel50-deals-table.selected')) {
      var first = document.querySelector('.cel50-deals-table')
      if (first && typeof window.cel50SelectDealQuantity === 'function') {
        window.cel50SelectDealQuantity(first.dataset.quantity)
      }
    }
  }

  document.addEventListener('submit', function (e) {
    var form = e.target
    if (!form || !form.matches('[data-cel50-form], [data-cel50-bundle-form]')) return

    e.preventDefault()
    e.stopPropagation()
    handleCheckout(form, e.submitter || null)
  })

  window.cel50Checkout = function (form) {
    if (form) handleCheckout(form, null)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady)
  } else {
    onReady()
  }
})()
